import DropdownSelect from './dropdown-select-component';
import './dropdown-select.scss';

const MODULE_NAME = 'app.common.widgets.dropdown-select';
const module = angular.module(MODULE_NAME, [])
    .directive(DropdownSelect.DIRECTIVE_NAME, DropdownSelect);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/dropdown-select/dropdown-select-module.js